/**
 * Object.hasOwn polyfill for ES2022 (used by refractor/react-syntax-highlighter in older envs).
 */
if (typeof Object.hasOwn !== "function") {
  Object.defineProperty(Object, "hasOwn", {
    value: function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
    configurable: true,
    writable: true,
  });
}

/**
 * Array.prototype.at polyfill for ES2022. Avoids "t.at is not a function" in older browsers or bundled deps.
 */
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, "at", {
    value: function (index) {
      var len = this.length;
      var relativeIndex = Math.trunc(index) || 0;
      var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
      return k < 0 || k >= len ? undefined : this[k];
    },
    configurable: true,
    writable: true,
  });
}